import { defineMessages } from 'react-intl';

const messages = defineMessages({
  applicationNotes: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.ApplicationNotes',
    defaultMessage: 'Application Notes',
  },
  waitlistNotes: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.WaitlistNotes',
    defaultMessage: 'Waitlist Notes',
  },
  waitlistDateTime: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.WaitlistDateTime',
    defaultMessage: 'Waitlist Date/Time',
  },
  application: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.Application',
    defaultMessage: 'Application',
  },
  applicationFees: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.ApplicationFees',
    defaultMessage: 'Application Fees',
  },
  unitAssigned: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.UnitAssigned',
    defaultMessage: 'Unit Assigned',
  },
  screening: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.Screening',
    defaultMessage: 'Screening',
  },
  applicationStatus: {
    id: 'LeaseApp.LeaseApplicationStatusTracker.ApplicationStatus',
    defaultMessage: 'Application Status',
  },
});

export default messages;
